goog.provide('el8.appshared.form.eligibilityFields');

el8.appshared.form.eligibilityFields = [
    {
        name: 'firstName',
        selector: ':input[name="firstName"]',
        infoText: 'First Name (required)',
        maxLength: 35,
        validate: {
            required: true,
            maxlength: 35
        }
    },
    {
        name: 'middleName',
        selector: ':input[name="middleName"]',
        infoText: 'Middle Name',
        maxLength: 35,
        validate: { maxlength: 35 }
    },
    {
        name: 'lastName',
        selector: ':input[name="lastName"]',
        infoText: 'Last Name (required)',
        maxLength: 35,
        validate: {
            required: true,
            maxlength: 35
        }
    },
    {
        name: 'dob',
        selector: ':input[name="dob"]',
        infoText: Date.format,
        datePickerOpts: {},
        validate: {
            required: true,
            validDate: true,
            todayOrBefore: true,
            afterYear1900 : true
        }
    },
    {
        name: 'sex',
        selector: ':input[name="sex"]',
        validate: { required: true }
    },
    {
        name: 'address',
        selector: ':input[name="address"]',
        infoText: 'Mailing Address',
        maxLength: 35,
        validate: { 
            maxlength: 35 
        }
    },
    {
        name: 'suite',
        selector: ':input[name="suite"]',
        infoText: 'Suite or Apartment No.',
        maxLength: 10,
        validate: { maxlength: 10 }
    },
    {
        name: 'city',
        selector: ':input[name="city"]',
        infoText: 'City',
        maxLength: 35,
        validate: { 
            maxlength: 35 
        }
    },
    {
        name: 'state',
        selector: ':input[name="state"]',
        infoText: 'XX',
        validate: { 
            state: true 
        }
    },
    {
        name: 'zip',
        selector: ':input[name="zip"]',
        infoText: 'XXXXX-XXXX',
        validate: { 
            zip: true 
        }
    },
    {
        name: 'phone1',
        selector: ':input[name="phone1"]',
        infoText: 'e.g. 555-555-5555',
        validate: { phone: true }
    },
    {
        name: 'phone1Type',
        selector: ':input[name="phone1Type"]',
        defaultVal: 'Home'
    },
    {
        name: 'phone2',
        selector: ':input[name="phone2"]',
        infoText: 'e.g. 555-555-5555',
        validate: { phone: true }
    },
    {
        name: 'phone2Type',
        selector: ':input[name="phone2Type"]',
        defaultVal: 'Cell Phone'
    }
];

